import { NgModule, } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AppComponent } from './app.component';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';


import { LoginComponent } from './components/login/login.component';


import { RestaurantComponent } from './components/restaurant/restaurant.component';
import { AddrestaurantComponent } from './components/restaurant/addrestaurant/addrestaurant.component';

import { CategoryComponent } from './components/category/category.component';
import { SubcategoryComponent } from './components/subcategory/subcategory.component';
import { AddsubcategoryComponent } from './components/subcategory/addsubcategory/addsubcategory.component';

import { UserComponent } from './components/user/user.component';
import { AdduserComponent } from './components/user/adduser/adduser.component';

import { ProductComponent } from './components/product/product.component';
import { AddproductComponent } from './components/product/addproduct/addproduct.component';
import { ProductviewComponent } from './components/product/productview/productview.component';

import { UserroleComponent } from './components/userrole/userrole.component';
import { AdduserroleComponent } from './components/userrole/adduserrole/adduserrole.component';
import { QuestionComponent } from './components/question/question.component';
import { AddquestionComponent } from './components/question/addquestion/addquestion.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { AddbranchComponent } from './components/branch/addbranch/addbranch.component';
import { BranchComponent } from './components/branch/branch.component';
import { BrandComponent } from './components/brand/brand.component';
import { AddbrandComponent } from './components/brand/addbrand/addbrand.component';
import { CardtypeComponent } from './components/cardtype/cardtype.component';
import { AddcardtypeComponent } from './components/cardtype/addcardtype/addcardtype.component';
import { CompanyComponent } from './components/company/company.component';
import { AddcompanyComponent } from './components/company/addcompany/addcompany.component';
import { CourseComponent } from './components/course/course.component';
import { AddcourseComponent } from './components/course/addcourse/addcourse.component';
import { CuisineComponent } from './components/cuisine/cuisine.component';
import { AddcuisineComponent } from './components/cuisine/addcuisine/addcuisine.component';
import { DepartmentComponent } from './components/department/department.component';
import { AdddepartmentComponent } from './components/department/adddepartment/adddepartment.component';
import { DinetypeComponent } from './components/dinetype/dinetype.component';
import { AdddinetypeComponent } from './components/dinetype/adddinetype/adddinetype.component';
import { GroupComponent } from './components/group/group.component';
import { AddgroupComponent } from './components/group/addgroup/addgroup.component';
import { SubgroupComponent } from './components/subgroup/subgroup.component';
import { AddsubgroupComponent } from './components/subgroup/addsubgroup/addsubgroup.component';
import { ModifierComponent } from './components/modifier/modifier.component';
import { AddmodifierComponent } from './components/modifier/addmodifier/addmodifier.component';
import { ModifiertypeComponent } from './components/modifiertype/modifiertype.component';
import { AddmodifiertypeComponent } from './components/modifiertype/addmodifiertype/addmodifiertype.component';
import { OrdermodeComponent } from './components/ordermode/ordermode.component';
import { AddordermodeComponent } from './components/ordermode/addordermode/addordermode.component';
import { PartyComponent } from './components/party/party.component';
import { AddpartyComponent } from './components/party/addparty/addparty.component';
import { ViewpartyComponent } from './components/party/viewparty/viewparty.component';
import { PaymentmodeComponent } from './components/paymentmode/paymentmode.component';
import { AddpaymentmodeComponent } from './components/paymentmode/addpaymentmode/addpaymentmode.component';
import { ReasonComponent } from './components/reason/reason.component';
import { AddreasonComponent } from './components/reason/addreason/addreason.component';
import { ShiftComponent } from './components/shift/shift.component';
import { AddshiftComponent } from './components/shift/addshift/addshift.component';
import { SizeComponent } from './components/size/size.component';
import { AddsizeComponent } from './components/size/addsize/addsize.component';
import { TaxComponent } from './components/tax/tax.component';
import { AddtaxComponent } from './components/tax/addtax/addtax.component';
import { UomComponent } from './components/uom/uom.component';
import { AdduomComponent } from './components/uom/adduom/adduom.component';
import { StationComponent } from './components/station/station.component';
import { AddstationComponent } from './components/station/addstation/addstation.component';
import { TablesectionComponent } from './components/tablesection/tablesection.component';
import { AddtablesectionComponent } from './components/tablesection/addtablesection/addtablesection.component';
import { TableComponent } from './components/table/table.component';
import { AddtableComponent } from './components/table/addtable/addtable.component';
import { FoodsymbolComponent } from './components/foodsymbol/foodsymbol.component';
import { AddfoodsymbolComponent } from './components/foodsymbol/addfoodsymbol/addfoodsymbol.component';
import { LocalityComponent } from './components/locality/locality.component';
import { AddlocalityComponent } from './components/locality/addlocality/addlocality.component';
import { BranchviewComponent } from './components/branch/branchview/branchview.component';
import { SettingsComponent } from './components/settings/settings.component';
import { OpenshiftComponent } from './components/openshift/openshift.component';
import { CurrencyComponent } from './components/currency/currency.component';
import { AddcurrencyComponent } from './components/currency/addcurrency/addcurrency.component';
import { IncomeComponent } from './components/income/income.component';
import { ChargesComponent } from './components/charges/charges.component';
import { ExpenseComponent } from './components/expense/expense.component';
import { VoucherComponent } from './components/voucher/voucher.component';
import { ReportComponent } from './components/report/report.component';
import { OpenbillreportComponent } from './components/report/openbillreport/openbillreport.component';
import { ProductquickmenuComponent } from './components/productquickmenu/productquickmenu.component';
import { ActivitylogreportComponent } from './components/report/activitylogreport/activitylogreport.component';
import { ShiftcloseemailComponent } from './components/shiftcloseemail/shiftcloseemail.component';
import { DinetypereportComponent } from './components/report/dinetypereport/dinetypereport.component';
import { ProductreportComponent } from './components/report/productreport/productreport.component';
import { GroupreportComponent } from './components/report/groupreport/groupreport.component';
import { DailyreportComponent } from './components/report/dailyreport/dailyreport.component';
import { EmployeeComponent } from './components/employee/employee.component';
import { TestComponent } from './components/test/test.component';
import { PurchaseComponent } from './componentstransaction/purchase/purchase.component';
import { AddpurchaseComponent } from './componentstransaction/purchase/addpurchase/addpurchase.component';
import { AddadjtypeComponent } from './components/adjtype/addadjtype/addadjtype.component';
import { AdjtypeComponent } from './components/adjtype/adjtype.component';
import { AdjComponent } from './componentstransaction/adj/adj.component';
import { AddadjComponent } from './componentstransaction/adj/addadj/addadj.component';
import { AddphysicalstockComponent } from './componentstransaction/physicalstock/addphysicalstock/addphysicalstock.component';
import { PhysicalstockComponent } from './componentstransaction/physicalstock/physicalstock.component';
import { StockreportComponent } from './components/report/stockreport/stockreport.component';
import { PurchasereportComponent } from './components/report/purchasereport/purchasereport.component';
import { AdjreportComponent } from './components/report/adjreport/adjreport.component';
import { ProductpriceComponent } from './components/productprice/productprice.component';
import { ProductcancelreportComponent } from './components/report/productcancelreport/productcancelreport.component';
import { BillcancelreportComponent } from './components/report/billcancelreport/billcancelreport.component';
import { BillsummaryreportComponent } from './components/report/billsummaryreport/billsummaryreport.component';
import { TaxsummaryreportComponent } from './components/report/taxsummaryreport/taxsummaryreport.component';
import { SalesxreportComponent } from './components/report/salesxreport/salesxreport.component';
import { IncometypeComponent } from './components/incometype/incometype.component';
import { AddincometypeComponent } from './components/incometype/addincometype/addincometype.component';
import { ExpensetypeComponent } from './components/expensetype/expensetype.component';
import { AddexpensetypeComponent } from './components/expensetype/addexpensetype/addexpensetype.component';
import { IncomereportComponent } from './components/report/incomereport/incomereport.component';
import { ExpensereportComponent } from './components/report/expensereport/expensereport.component';
import { HourlyitemsalesreportComponent } from './components/report/hourlyitemsalesreport/hourlyitemsalesreport.component';
import { PaymentwiseorderreportComponent } from './components/report/paymentwiseorderreport/paymentwiseorderreport.component';
import { StationwisereportComponent } from './components/report/stationwisereport/stationwisereport.component';
import { TablesectionviewComponent } from './components/tablesection/tablesectionview/tablesectionview.component';
import { PricetypeComponent } from './components/pricetype/pricetype.component';
import { KitchennotesComponent } from './components/kitchennotes/kitchennotes.component';
import { AddkitchennotesComponent } from './components/kitchennotes/addkitchennotes/addkitchennotes.component';
import { ItemcategoryComponent } from './components/itemcategory/itemcategory.component';
import { AdditemcategoryComponent } from './components/itemcategory/additemcategory/additemcategory.component';
import { RawmaterialComponent } from './components/rawmaterial/rawmaterial.component';
import { AddrawmaterialComponent } from './components/rawmaterial/addrawmaterial/addrawmaterial.component';
import { AddpurchasereturnComponent } from './componentstransaction/purchasereturn/addpurchasereturn/addpurchasereturn.component';
import { PurchasereturnComponent } from './componentstransaction/purchasereturn/purchasereturn.component';
import { OrdermodereportComponent } from './components/report/ordermodereport/ordermodereport.component';
import { DiscountreportComponent } from './components/report/discountreport/discountreport.component';
import { TablesectionreportComponent } from './components/report/tablesectionreport/tablesectionreport.component';
import { TablereportComponent } from './components/report/tablereport/tablereport.component';
import { CustomerreportComponent } from './components/report/customerreport/customerreport.component';
import { BillcancelsummaryreportComponent } from './components/report/billcancelsummaryreport/billcancelsummaryreport.component';
import { LocalityreportComponent } from './components/report/localityreport/localityreport.component';
import { ComplimentoryreportComponent } from './components/report/complimentoryreport/complimentoryreport.component';
import { FastmovingreportComponent } from './components/report/fastmovingreport/fastmovingreport.component';
import { VariationreportComponent } from './components/report/variationreport/variationreport.component';
import { CashierreportComponent } from './components/report/cashierreport/cashierreport.component';
import { WaiterreportComponent } from './components/report/waiterreport/waiterreport.component';
import { PaymentmodereportComponent } from './components/report/paymentmodereport/paymentmodereport.component';
import { RecipeComponent } from './components/recipe/recipe.component';
import { AddrecipeComponent } from './components/recipe/addrecipe/addrecipe.component';
import { ReceiptsettingsComponent } from './components/receiptsettings/receiptsettings.component';
import { SupportComponent } from './components/support/support.component';
import { DevicesComponent } from './components/devices/devices.component';
import { AdddevicesComponent } from './components/devices/adddevices/adddevices.component';
import { ConfigrationComponent } from './components/configration/configration.component';
import { OutletsettingsComponent } from './components/outletsettings/outletsettings.component';
import { EditprofileComponent } from './components/user/editprofile/editprofile.component';
import { PosexpiryComponent } from './components/grid/posexpiry/posexpiry.component';
import { DashboardorganizationComponent } from './dashboardorganization/dashboardorganization.component';
import { SalesactivitylogreportComponent } from './components/report/salesactivitylogreport/salesactivitylogreport.component';
import { TabledesignviewComponent } from './components/tablesection/tabledesignview/tabledesignview.component';
import { LpoComponent } from './componentstransaction/lpo/lpo.component';
import { TransferComponent } from './componentstransaction/transfer/transfer.component';
import { AccountComponent } from './components/account/account.component';
import { AddaccountComponent } from './components/account/addaccount/addaccount.component';
import { AccounttypeComponent } from './components/accounttype/accounttype.component';
import { AddaccounttypeComponent } from './components/accounttype/addaccounttype/addaccounttype.component';
import { AddcostcenterComponent } from './components/costcenter/addcostcenter/addcostcenter.component';
import { CostcenterComponent } from './components/costcenter/costcenter.component';
import { DefaultledgerComponent } from './components/defaultledger/defaultledger.component';
import { AccountsreportComponent } from './components/report/accountsreport/accountsreport.component';
import { BalancesheetreportComponent } from './components/report/balancesheetreport/balancesheetreport.component';
import { PayablereportComponent } from './components/report/payablereport/payablereport.component';
import { ProfitlossreportComponent } from './components/report/profitlossreport/profitlossreport.component';
import { ReceivablereportComponent } from './components/report/receivablereport/receivablereport.component';
import { TrailbalancereportComponent } from './components/report/trailbalancereport/trailbalancereport.component';
import { AddsubledgerComponent } from './components/subledger/addsubledger/addsubledger.component';
import { SubledgerComponent } from './components/subledger/subledger.component';
import { AddsubledgertypeComponent } from './components/subledgertype/addsubledgertype/addsubledgertype.component';
import { SubledgertypeComponent } from './components/subledgertype/subledgertype.component';
import { AddjournalvoucherComponent } from './componentstransaction/journalvoucher/addjournalvoucher/addjournalvoucher.component';
import { JournalvoucherComponent } from './componentstransaction/journalvoucher/journalvoucher.component';
import { PaymentComponent } from './componentstransaction/payment/payment.component';
import { TemplatesettingsComponent } from './components/templatesettings/templatesettings.component';
import { CustomerstatementreportComponent } from './components/report/customerstatementreport/customerstatementreport.component';
import { StockrangereportComponent } from './components/report/stockrangereport/stockrangereport.component';
import { DailyshiftreportComponent } from './components/report/dailyshiftreport/dailyshiftreport.component';
import { OutletshiftclosereportComponent } from './components/report/outletshiftclosereport/outletshiftclosereport.component';
import { OutletcustomerfootfallreportComponent } from './components/report/outletcustomerfootfallreport/outletcustomerfootfallreport.component';
import { OutletnewcustomerreportComponent } from './components/report/outletnewcustomerreport/outletnewcustomerreport.component';
import { ExpensedetailsreportComponent } from './components/report/expensedetailsreport/expensedetailsreport.component';
import { XferComponent } from './componentstransaction/xfer/xfer/xfer.component';
import { AddxferComponent } from './componentstransaction/xfer/addxfer/addxfer.component';
import { OutletwisesalesreportComponent } from './components/report/outletwisesalesreport/outletwisesalesreport.component';
import { DailypaymentreportComponent } from './components/report/dailypaymentreport/dailypaymentreport.component';


const routes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'Dashboard', component: DashboardComponent },
  { path: 'DashboardOrganization', component: DashboardorganizationComponent },
  { path: 'Login', component: LoginComponent },
  { path: 'Restaurant', component: RestaurantComponent },
  { path: 'AddRestaurant', component: AddrestaurantComponent },
  { path: 'Category', component: CategoryComponent },
  { path: 'Subcategory', component: SubcategoryComponent },
  { path: 'AddSubcategory', component: AddsubcategoryComponent },
  { path: 'User', component: UserComponent },
  { path: 'AddUser', component: AdduserComponent },
  { path: 'Product', component: ProductComponent },
  { path: 'AddProduct', component: ProductviewComponent },
  { path: 'Userrole', component: UserroleComponent },
  { path: 'AddUserrole', component: AdduserroleComponent },
  { path: 'Question', component: QuestionComponent },
  { path: 'AddQuestion', component: AddquestionComponent },
  { path: 'Feedback', component: FeedbackComponent },
  { path: 'AddCompany', component: AddcompanyComponent }, 
  { path: 'Group', component: GroupComponent },
  { path: 'AddGroup', component: AddgroupComponent },
  // { path: 'Subgroup', component: SubgroupComponent },
  // { path: 'AddSubgroup', component: AddsubgroupComponent },
  { path: 'Modifier', component: ModifierComponent },
  { path: 'AddModifier', component: AddmodifierComponent },
  { path: 'Modifiertype', component: ModifiertypeComponent },
  { path: 'AddModifiertype', component: AddmodifiertypeComponent },
  { path: 'Ordermode', component: OrdermodeComponent },
  { path: 'AddOrdermode', component: AddordermodeComponent },
  { path: 'Party', component: PartyComponent },
  { path: 'AddParty', component: AddpartyComponent },
  { path: 'ViewParty', component: ViewpartyComponent },  
  { path: 'Reason', component: ReasonComponent },
  { path: 'AddReason', component: AddreasonComponent },
  { path: 'Size', component: SizeComponent },
  { path: 'AddSize', component: AddsizeComponent },
  { path: 'Tax', component: TaxComponent },
  { path: 'AddTax', component: AddtaxComponent },
  { path: 'Uom', component: UomComponent },
  { path: 'AddUom', component: AdduomComponent },
  { path: 'TableSection', component: TablesectionComponent },
  { path: 'AddTableSection', component: AddtablesectionComponent },
  { path: 'ViewTableSection', component: TablesectionviewComponent },
  { path: 'Table', component: TableComponent },
  { path: 'AddTable', component: AddtableComponent },  
  { path: 'Locality', component: LocalityComponent },
  { path: 'AddLocality', component: AddlocalityComponent },
  { path: 'Sales', component: DashboardComponent },
  { path: 'Settings', component: SettingsComponent },
  { path: 'OpenShift', component: OpenshiftComponent },
  { path: 'Currency', component: CurrencyComponent },
  { path: 'Income', component: IncomeComponent },
  { path: 'Charges', component: ChargesComponent },
  { path: 'Expense', component: ExpenseComponent },
  { path: 'Voucher', component: VoucherComponent },
  { path: 'Report', component: ReportComponent },
  { path: 'OpenBillReport', component: OpenbillreportComponent },
  { path: 'ProductQuickMenu', component: ProductquickmenuComponent },
  { path: 'ActivitylogReport', component: ActivitylogreportComponent },
  { path: 'ShiftCloseEmail', component: ShiftcloseemailComponent },
  { path: 'DinetypeReport', component: DinetypereportComponent },
  { path: 'ProductReport', component: ProductreportComponent },
  { path: 'GroupReport', component: GroupreportComponent },
  { path: 'DailyReport', component: DailyreportComponent },
  { path: 'Employee', component: EmployeeComponent },
  { path: 'Test', component: TestComponent },
  { path: 'Purchase', component: PurchaseComponent },
  { path: 'AddPurchase', component: AddpurchaseComponent },
  { path: 'Adjtype', component: AdjtypeComponent },
  { path: 'AddAdjtype', component: AddadjtypeComponent },
  { path: 'Adj', component: AdjComponent },
  { path: 'AddAdj', component: AddadjComponent },
  { path: 'Physicalstock', component: PhysicalstockComponent },
  { path: 'AddPhysicalstock', component: AddphysicalstockComponent },
  { path: 'StockReport', component: StockreportComponent },
  { path: 'PurchaseReport', component: PurchasereportComponent },
  { path: 'AdjReport', component: AdjreportComponent },  
  { path: 'ProductPrice', component: ProductpriceComponent },
  { path: 'ProductCancelReport', component: ProductcancelreportComponent },
  { path: 'BillCancelReport', component: BillcancelreportComponent },
  { path: 'BillSummaryReport', component: BillsummaryreportComponent },
  { path: 'TaxSummaryReport', component: TaxsummaryreportComponent },
  { path: 'SalesXReport', component: SalesxreportComponent },
  { path: 'Incometype', component: IncometypeComponent },
  { path: 'AddIncometype', component: AddincometypeComponent },
  { path: 'Expensetype', component: ExpensetypeComponent },
  { path: 'AddExpensetype', component: AddexpensetypeComponent },
  { path: 'IncomeReport', component: IncomereportComponent },
  { path: 'ExpenseReport', component: ExpensereportComponent },
  { path: 'ExpenseDetailsReport', component: ExpensedetailsreportComponent },
  { path: 'HourlyitemsalesReport', component: HourlyitemsalesreportComponent },
  { path: 'PaymentwiseOrderReport', component: PaymentwiseorderreportComponent },
  { path: 'StationwiseReport', component: StationwisereportComponent },
  { path: 'Pricetype', component: PricetypeComponent },
  { path: 'Kitchennotes', component: KitchennotesComponent },
  { path: 'AddKitchennotes', component: AddkitchennotesComponent },
  { path: 'Itemcategory', component: ItemcategoryComponent },
  { path: 'AddItemcategory', component: AdditemcategoryComponent },
  { path: 'Rawmaterial', component: RawmaterialComponent },
  { path: 'AddRawmaterial', component: AddrawmaterialComponent },
  { path: 'PurchaseReturn', component: PurchasereturnComponent },
  { path: 'AddPurchaseReturn', component: AddpurchasereturnComponent },
  { path: 'Recipe', component: RecipeComponent },
  { path: 'AddRecipe', component: AddrecipeComponent },
  { path: 'ReceiptSettings', component: ReceiptsettingsComponent },

  { path: 'OrderModeReport', component: OrdermodereportComponent },
  { path: 'DiscountReport', component: DiscountreportComponent },
  { path: 'PaymentModeReport', component: PaymentmodereportComponent },
  { path: 'TableSectionReport', component: TablesectionreportComponent },
  { path: 'TableReport', component: TablereportComponent },
  { path: 'CustomerReport', component: CustomerreportComponent },
  { path: 'BillCancelSummaryReport', component: BillcancelsummaryreportComponent },
  { path: 'LocalityReport', component: LocalityreportComponent },
  { path: 'ComplimentoryReport', component: ComplimentoryreportComponent },
  { path: 'FastMovingReport', component: FastmovingreportComponent },
  { path: 'VariationReport', component: VariationreportComponent },
  { path: 'CashierReport', component: CashierreportComponent },
  { path: 'WaiterReport', component: WaiterreportComponent },
  { path: 'TaxReport', component: TaxsummaryreportComponent },
  { path: 'SalesActivitylogReport', component: SalesactivitylogreportComponent },
  { path: 'AccountsReport', component: AccountsreportComponent },
  { path: 'TrailBalanceReport', component: TrailbalancereportComponent },
  { path: 'ProfitLossReport', component: ProfitlossreportComponent },
  { path: 'BalanceSheetReport', component: BalancesheetreportComponent },
  { path: 'PayableReport', component: PayablereportComponent },
  { path: 'ReceivableReport', component: ReceivablereportComponent },
  { path: 'CustomerStatementReport', component: CustomerstatementreportComponent },
  { path: 'StockRangeReport', component: StockrangereportComponent },
  { path: 'DailyShiftReport', component: DailyshiftreportComponent },
  { path: 'DailyPaymentReport', component: DailypaymentreportComponent },
  { path: 'OutletWiseShiftCloseReport', component: OutletshiftclosereportComponent },
  { path: 'OutletWiseNewCustomerReport', component: OutletnewcustomerreportComponent },
  { path: 'OutletWiseFootFallReport', component: OutletcustomerfootfallreportComponent },
  { path: 'OutletWiseSalesReport', component: OutletwisesalesreportComponent },
  

  { path: 'Support', component: SupportComponent },
  { path: 'Station', component: StationComponent },
  { path: 'AddStation', component: AddstationComponent },
  { path: 'Devices', component: DevicesComponent },
  { path: 'AddDevices', component: AdddevicesComponent },

  { path: 'Configration', component: ConfigrationComponent },
  { path: 'OutletDetails', component: OutletsettingsComponent },
  { path: 'EditProfile', component: EditprofileComponent },
  { path: 'Expiry', component: PosexpiryComponent },


  { path: 'TableDesignView', component: TabledesignviewComponent },
  { path: 'Lpo', component: LpoComponent },
  { path: 'Transfer', component: TransferComponent },
  { path: 'AccountType', component: AccounttypeComponent },
  { path: 'AddAccountType', component: AddaccounttypeComponent },
  { path: 'Account', component: AccountComponent },
  { path: 'AddAccount', component: AddaccountComponent },
  { path: 'SubledgerType', component: SubledgertypeComponent },
  { path: 'AddSubledgerType', component: AddsubledgertypeComponent },
  { path: 'Subledger', component: SubledgerComponent },
  { path: 'AddSubledger', component: AddsubledgerComponent },
  { path: 'CostCenter', component: CostcenterComponent },
  { path: 'AddCostCenter', component: AddcostcenterComponent },
  { path: 'JournalVoucher', component: JournalvoucherComponent },
  { path: 'AddJournalVoucher', component: AddjournalvoucherComponent },
  { path: 'Defaultledger', component: DefaultledgerComponent },
  { path: 'Payment', component: PaymentComponent },
  { path: 'TemplateSettings', component: TemplatesettingsComponent },
  { path: 'Xfer', component: XferComponent },
  { path: 'AddXfer', component: AddxferComponent },
];







 
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true }), CommonModule],
  //imports: [RouterModule.forRoot(routes, { useHash: false })], 
  exports: [RouterModule],
  //providers:[Location,{provide:LocationStrategy,useClass:PathLocationStrategy}]
})

export class AppRoutingModule { }
